import * as React from "react"
import {Navigate, useSearchParams} from "react-router-dom";
import {useSignal} from "@preact/signals-react";
import {Alert, AlertTitle, Box, CircularProgress, Drawer, Typography} from "@mui/material"
import {ButtonLoadingSeeker, ImageSeeker, PasswordFieldSeeker, TextFieldSeeker} from "@ui-seeker/core";

import {useUserApp} from "@hooks";
import NoDipiAccessModal from "../@components/NoDipiAccessModal";
import {drawerStyles} from "./@styles";


export default function LoginPage() {
    const [searchParams] = useSearchParams()
    const launch = searchParams.get('launch')
	const redirect = searchParams.get('redirect')
    const { isLogged, checkingLogging, isLoadingLogin, handleLogin, error, noDipiAccess } = useUserApp(true)
    const username = useSignal('')
    const password = useSignal('')

    let redirectUrl = '/'
	if (redirect)
		redirectUrl = redirect + (launch === 'true' ? '&launch=true': '')

    if (isLogged) {
        if (redirect) return <Navigate to={redirectUrl} replace />
        else return <Navigate to="/" replace />
    }

    const handleSubmit = e => {
        e.preventDefault()
        handleLogin(username.value, password.value)
    }

    return <>

        <Box sx={{
            width: 0.7,
            height: '100vh',
            backgroundImage: `url('/images/background_login.jpg')`,
            backgroundSize: 'cover'
        }} />

        <Box component="form" onSubmit={handleSubmit}>
            <Drawer PaperProps={{ sx: drawerStyles }} variant="permanent" anchor="right">

                <Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mb: 5 }}>
                    <ImageSeeker src="/images/dipi_ico.png" sx={{ width: '50px',mr: 2 }} />
                    <Typography  variant="h4" sx={{ mr: 0.8}}>DIP Insights</Typography>
                    <Typography variant="caption">by Data seekers</Typography>
                </Box>

                <Typography variant="h4" sx={{ mb: 2.5 }}>
                    User log in
                </Typography>

                { !!checkingLogging && <Box sx={{ width: '70%', textAlign: 'center' }}>
                    <Typography sx={{ mb: 3, color: 'text.secondary' }}>
                        Check user login
                    </Typography>

                    <CircularProgress size={60} />
                </Box> }

                { !checkingLogging && <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: .6 }}>

                    { !!error && <Alert severity="error">
                        <AlertTitle>Login Error</AlertTitle>
                        {error}
                    </Alert>  }

                    <TextFieldSeeker
                        placehoder="Email"
                        value={username.value}
                        onChange={e => username.value = e.target.value}
                        startIcon="envelope"
                    />

                    <PasswordFieldSeeker
                        value={password.value}
                        onChange={e => password.value = e.target.value}
                        startIcon="lock"
                    />

                    <ButtonLoadingSeeker
                        type="submit"
                        loading={isLoadingLogin}
                    >
                        Log in
                    </ButtonLoadingSeeker>
                </Box> }

            </Drawer>
        </Box>

        <NoDipiAccessModal open={noDipiAccess} />

    </>
}
